import TrangThaiNoiTru from "./TrangThaiNoiTru"
export default TrangThaiNoiTru